import { Lock, FlaskConical, FileCheck, Snowflake } from "lucide-react";
const badges = [{
  id: "ssl",
  label: "SSL Secured Checkout",
  icon: Lock
}, {
  id: "lab",
  label: "Third-Party Lab Tested",
  icon: FlaskConical
}, {
  id: "coa",
  label: "COA Included with Every Order",
  icon: FileCheck
}, {
  id: "cold",
  label: "Cold-Chain Shipping",
  icon: Snowflake
}];
export default function TrustBadges() {
  return <section id="trustbadges" className="bg-background">
      <div className="bg-card border-y border-border py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-0 lg:divide-x divide-border">
            {badges.map((badge, i) => {
            const Icon = badge.icon;
            return <div key={badge.id} data-index={i} className="flex flex-col items-center justify-center text-center px-4 gap-6">
                  <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} aria-hidden="true" />
                  <span className="text-foreground font-semibold tracking-tight text-2xl">
                    {badge.label}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}